// extracted by mini-css-extract-plugin
module.exports = {"title":"MobileTextBanner_title__3eXWZ","subTitle":"MobileTextBanner_subTitle__1h35N","card":"MobileTextBanner_card__xVGcP","actions":"MobileTextBanner_actions__33C9K"};